export default [
  {
    path: '/additional-visitors/:id',
    name: 'additional-visitor-details',
    meta: {
      protected: true,
      pageTitle: 'Additional Visitor Details',
    },
    component: () => import('@/views/additionalVisitors/AdditionalVisitorDetails.vue'),
  },
  {
    path: '/additional-visitors/create',
    name: 'create-additional-visitor',
    meta: {
      protected: true,
      pageTitle: 'Create Additional Visitor',
    },
    component: () => import('@/views/additionalVisitors/CreateAdditionalVisitor.vue'),
  },
];
